module.exports = __webpack_public_path__ + "hk.svg?df295e8678086ce1f1b4785bb6a3f29c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/hk.svg
// module id = 1270
// module chunks = 27